import Vue from 'vue';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import VueMask from 'v-mask';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import * as VueGoogleMaps from 'vue2-google-maps';

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyBUkUxcaqknp8CD-ukCsxmUWimfud7l3ts',
        //key: 'AIzaSyB2AR_DQXGIBLWEnzlKAIVQhngBPvjYmCs',
        libraries: 'places',
    }
});

Vue.use(VeeValidate, {
    classes: true,
    classNames: {
        valid: 'is-valid',
        invalid: 'is-invalid'
    }
});

Vue.use(Loading);
Vue.use(VueMask);
Vue.use(BootstrapVue);

var app = new Vue({
    el: '#contactData',

    data: {
        allPersons: [],
        persons: [],
        searchString: '',
        expandMap: false,
        sortColumn: null,
        ascSort: true,
        isActive: true,
        activeRow: null
    },

    watch: {
        allPersons: function (val) {
            var self = this;
            //console.log(val);
            self.persons = val.slice(); // copy of object
            this.sortPersons('Name');
        },

        searchString: function (val) {
            var self = this;
            self.activeRow = null;
            self.persons = [];

            if (val.length === 0) {
                self.persons = self.allPersons;
            }
            else {
                var array = self.allPersons;
                array.forEach(function (element) {
                    var name = element.Name.toLowerCase();
                    if (name.includes(val.toLowerCase())) {
                        self.persons.push(element);
                    }
                });
            }
        },
    },

    methods: {
        getPersons: function () {
            let loader = this.$loading.show({
                loader: 'spinner',
                color: '#007bff'
            });
            axios.get('/umbraco/Surface/ContactUs/GetPersons/')
                .then((response) => {
                    if (response.data !== 'error') {
                        this.allPersons = response.data.sort(this.dynamicSort('Name', this.ascSort));
                    }
                    loader.hide();
                })
                .catch(function (error) {
                    //console.log(error);
                    loader.hide();
                });
        },

        sortPersons: function (prop) {
            var unsorted = this.persons;

            if (this.sortColumn === null || this.sortColumn !== prop) {
                this.sortColumn = prop;
                this.ascSort = true;
            }
            else
            {
                this.ascSort = !this.ascSort;
            }

            this.persons = unsorted.sort(this.dynamicSort(prop, this.ascSort));
        },

        dynamicSort: function (property, asc) {
            var sortOrder = 1;
            if (!asc) {
                sortOrder = -1;
            }
            return function (a, b) {
                /* next line works with strings and numbers, 
                 * and you may want to customize it to your needs
                 */
                var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
                return result * sortOrder;
            }
        },

        setActiveRow: function(rowNumber) {
            if (this.activeRow === rowNumber) {
                this.activeRow = null;
            }
            else {
                this.activeRow = rowNumber;
            }
        },

        successSending: function() {
            this.makeToast('Suksess', 'Melding sendt.', 'success');
        },

        makeToast(title, body, variant) {
            this.$bvToast.toast(body, {
                title: title,
                variant: variant,
                solid: true
            });
        },

        formatMobile(value) {
            return value.replace(/^(\d{3})(\d{2})(\d{3})$/, '$1 $2 $3');
        },

        formatPhone(value) {
            return value.replace(/^(.{2})(.{2})(.{2})(.{2})$/, '$1 $2 $3 $4')
        },
    },

    mounted() {
        this.getPersons();
    }
});


// WEBPACK FOOTER //
// ./Scripts/app/contactUs/index.js